import { WorkItemLaneModel } from '../shared/services/lane-manager/work-item-lane.model';
import { WorkItemLaneType } from '../shared/services/lane-manager/work-item-lane-type.enum';

export const EmailLayout: WorkItemLaneModel[] = [
  {
    id: WorkItemLaneType.CannedMessage.toString(),
    name: 'CANNED_MESSAGES',
    type: WorkItemLaneType.CannedMessage,
    width: 1,
    visible: false,
    icon: 'can-outline',
    tooltip: 'tooltips.cannedMessages'
  },
  {
    id: WorkItemLaneType.Discussions.toString(),
    name: 'DISCUSSIONS',
    type: WorkItemLaneType.Discussions,
    width: 1,
    visible: false,
    icon: 'discussions',
    tooltip: 'tooltips.discussions'
  },
  {
    id: WorkItemLaneType.VisitorInfo.toString(),
    name: 'VISITOR_INFO',
    type: WorkItemLaneType.VisitorInfo,
    width: 1,
    visible: true,
    icon: 'info-outline',
    tooltip: 'tooltips.visitorInfo'
  }
];
